export default [
  {
    name: 'contadores',
    path: '/contadores',
    component: () => import(/* webpackChunkName: "contadores" */ './Contadores')
  }
]
